<template lang="pug">
.columns.align-center.col-gapless
  .column
    input.form-input(type="file" :disabled="loading" :class="{ loading }" @input="onInputFile" v-bind="inputAttrs")
  .column.col-auto(v-if="value && showPreview")
    .popover.popover-left
      a.btn.btn-primary.btn-auto #[i.fas.fa-eye]
      .popover-container
        .card
          .card-body.flex-centered
            img.img-responsive(:src="value")
</template>

<script>
import upload from '@/services/upload'

export default {
  props: {
    value: { type: String, default: '' },
    showPreview: { type: Boolean, default: true },
    inputAttrs: { type: Object, default: () => ({}) },
  },
  data() {
    return { loading: false }
  },
  methods: {
    async onInputFile(event) {
      try {
        this.loading = true
        this.$emit('upload-start')
        const [file] = event.target.files
        const { data } = await upload.send(file)
        this.$emit('input', data.url)
        this.$emit('upload-done', data)
      } catch (e) {
        this.$emit('upload-error', e)
      } finally {
        this.loading = false
        this.$emit('upload-end')
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.btn-auto
  height 42px
  width 42px
  border-top-left-radius 0
  border-bottom-left-radius 0
  display flex
  align-items center
  justify-content center
</style>
